import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./router.rule";
import Store from "../store/index";
import { Loading, Message } from "element-ui";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savePosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0
    };
  }
});
let loading;
router.beforeEach((to, from, next) => {
  // 跳转帮助手册所用
  if (to.path != '/buyerHelpManual') {
    let toBuyerHelpManualUrl = to.path;
    localStorage.toBuyerHelpManualUrl = JSON.stringify(toBuyerHelpManualUrl);
  }
  loading = Loading.service({
    spinner: "el-icon-loading",
    //loading样式类名
    background: "rgba(0,0,0,0)",
    text: "正在加载页面..."
  });
  // 由于未登录也可查看首页和商品查询页以及详情页，所以此处针对未登录的判断 暂时注释掉
  // if (!Store.state.token || Store.state.token == "undefined") {
  //   if (to.path == "/login" || to.path == "/register" ) {
  //     next();
  //   } else {
  //     Message.warning("未登录，为您跳转登录页面。。。")
  //     next({ path: "/login" });
  //   }
  // } 
  // else {
  // 由于普通用户可登录查看首页及商品查询，不需要先进行认证，所以此项判断先注释掉
  //   if(Store.state.user.userType == 0 && to.path != "/enterprise-bindingBusiness"){
  //     Message.warning("您还未进行认证，不允许操作当前系统，请先进行企业认证。。。")
  //     next({ path: "/enterprise-bindingBusiness" });
  //   }else{
  //     next();
  //   }
  // }
  // 上述未登录的判断暂时更改为以下逻辑
  const whiteList = ["/login", "/home", "/goods-search", "/detail", "/chat", "/register", "/buyerHelpManual", "/information"];
  if (!Store.state.token || Store.state.token == "undefined") {
    if (whiteList.includes(to.path)) {
      next();
    }
  } else {
    const whiteList = ["/login", "/home", "/goods-search", "/detail", "/chat", "/register", "/enterprise-maintain", "/enterprise-maintain", "/buyerHelpManual", "/information"];
    if (!Store.state.user.userType || Store.state.user.userType == 0) {
      if (whiteList.includes(to.path)) {
        next();
      }
    } else {
      next();
    }
  }
  loading.close();
});
if (localStorage.accessToken) {
  Store.commit("updateToken", localStorage.accessToken);
}
if (localStorage.user) {
  Store.commit("updateUser", JSON.parse(localStorage.user));
}
export default router;